import axios from 'axios';

const state = () => ({
	test: null,
	testBank: null,
	testTracks: null,
	allTestsOfUser: null,
});

const getters = {
	test: (state) => {
		return state.test;
	},
	testBank: (state) => {
		return state.testBank;
	},
	allTestsOfUser: (state) => {
		return state.allTestsOfUser;
	},
};
const mutations = {
	setTest(state, test) {
		state.test = test;
	},
	setTestBank(state, testBank) {
		state.testBank = testBank;
	},
	setTestTracks(state, testTracks) {
		state.testTracks = testTracks;
	},
	setAllTestsOfUser(state, tests) {
		state.allTestsOfUser = tests;
	},
	clearStore(state) {
		state.test = null;
		state.testBank = null;
		state.testTracks = null;
	},
};
const actions = {
	async fetchTest(store, { testId }) {
		if (localStorage.getItem('token') != null) {
			axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
		}
		const testRes = await axios.get('/api/tests/' + testId);
		const test = testRes.data.test;

		const testBankRes = await axios.get('/api/testBanks/' + test.test_bank_id);
		const testBank = testBankRes.data.testBank;

		return { test, testBank };
	},
	/** Fetch test also fetch test bank to have detail */
	async fetchAndSetTest(store, { testId, userId }) {
		if (localStorage.getItem('token') != null) {
			axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
		}
		const [testRes, candidateInTestRes] = await Promise.all([
			axios.get('/api/tests/' + testId),
			axios.get(`/api/tests/candidates/${testId}/${userId}`),
		]);
		const test = testRes.data.test;

		if (candidateInTestRes.data.candidateInTest && candidateInTestRes.data.candidateInTest.special_due_date) {
			test.due_date = candidateInTestRes.data.candidateInTest.special_due_date;
		}

		const testBankRes = await axios.get('/api/testBanks/' + test.test_bank_id);
		const testBank = testBankRes.data.testBank;

		store.commit('setTest', test);
		store.commit('setTestBank', testBank);
		return { test, testBank };
	},
	async checkUserIsInTest(store, { testId, userId }) {
		const res = await axios.post('/api/tests/check-user-in-test', { testId, userId });
		return res.data.isInTest;
	},
	async fetchAndSetTestTracks(store, { testBankId }) {
		const res = await axios.get(`/api/testBanks/${testBankId}/tracks`);
		store.commit('setTestTracks', res.data.testTracks);
		return res.data.testTracks;
	},
	async fetchAllUserTests(store, { userId }) {
		const res = await axios.get(`/api/tests/user/${userId}`); // Tests are overrided due date by special due date
		return res.data.tests;
	},
	async searchTestBanks(store, { testBankIds }) {
		if (localStorage.getItem('token') != null) {
			axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
		}
		const res = await axios.post('/api/testBanks/search', { ids: testBankIds });
		return res.data.testBanks;
	},
	async fetchTestBankById(store, { testBankId }) {
		if (localStorage.getItem('token') != null) {
			axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
		}
		const res = await axios.get('/api/testBanks/' + testBankId);
		return res.data.testBank;
	},
	async createEndParcoursTest(store, { userId, parcoursId }) {
		try {
			if (localStorage.getItem('token') != null) {
				axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
			}
			const res = await axios.post('/api/tests/end-parcours/create', { userId, parcoursId });
			return res.data;
		} catch (error) {
			console.error(error);
		}
	},
	setAllTestsOfUserAction(store, testsOfUser) {
		store.commit('setAllTestsOfUser', testsOfUser);
	},
	clear(store) {
		store.commit('clearStore');
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
